import { useState } from "react";

const DeleteConfirmation = ({ isOpen, onCancel, onDelete,headerText="Confirm Submission",yesButtonText="SUBMIT",warningMessageText="Are you sure you want to submit the form?" }) => {
    
  

  return (
    <div className={`w-full bg-pink-100 transition-all duration-500 overflow-hidden ${
        isOpen ? "max-h-[1000px] opacity-100 scale-100" : "max-h-0 opacity-0 scale-100"
      }`}>
      <div className="bg-white p-6 rounded-lg shadow-xl  text-center">
        <h2 className="text-lg font-semibold text-gray-800">{headerText}</h2>
        <p className="text-gray-600 mt-2">{warningMessageText}</p>
        
        <div className="flex justify-end mt-4 space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 transition"
          >
            CANCEL
          </button>
          <button
            onClick={onDelete}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
          >
            {yesButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};
export default DeleteConfirmation;


